module.exports = __webpack_public_path__ + "img/back_arrow.4e9406c7.svg";